import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconCartOutline = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-cart-outline"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    className={clsxm('size-8 text-black', className)}
    {...props}
  >
    <path
      d="M12 4L9.33333 12M20 4L22.6667 12M16 22.6667V17.3333M10.6667 22.6667V17.3333M21.3333 22.6667V17.3333M24.2 28H7.8C7.48041 28.0041 7.16998 27.8933 6.92525 27.6877C6.68052 27.4821 6.51778 27.1955 6.46667 26.88L4 12H28L25.52 26.88C25.4692 27.1932 25.3084 27.4781 25.0665 27.6834C24.8245 27.8886 24.5173 28.0009 24.2 28V28Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
